
export default {
  fetch() {
    return this.checkIfFacebookLoginAllowed()
  },

  data() {
    return { isFacebookAuthAllowed: false }
  },

  computed: {
    isEnabled() {
      return this.$config.facebook.isEnabled && this.isFacebookAuthAllowed
    },
  },

  methods: {
    async checkIfFacebookLoginAllowed() {
      try {
        const isAllowed = await this.$store.dispatch(
          'authentication/isFacebookAuthAllowed'
        )
        this.isFacebookAuthAllowed = isAllowed
      } catch (error) {
        // don't show error message
        console.error(error)
      }
    },

    handleClick() {
      this.$auth.loginWith('facebook')
    },
  },
}
